import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 14.222,
	viewBox: "0 0 16 14.222",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "perm_media-24px",
		transform: "translate(1)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_6444",
			"data-name": "Group 6444",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3817",
				"data-name": "Rectangle 3817",
				width: 14,
				height: 14.222,
				fill: "none"
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_6446",
			"data-name": "Group 6446",
			transform: "translate(-1)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_6445",
				"data-name": "Group 6445",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_19149",
					"data-name": "Path 19149",
					d: "M11.421,17.459H2.158V6.881C2.158,6.4,1.9,6,1.579,6S1,6.4,1,6.881V17.459c0,.97.521,1.763,1.158,1.763h9.263c.318,0,.579-.4.579-.881S11.739,17.459,11.421,17.459Z",
					transform: "translate(1 -6)",
					fill: "#fff"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_19150",
					"data-name": "Path 19150",
					d: "M19.222,3.763H13L11.747,2.52A1.791,1.791,0,0,0,10.484,2H6.778A1.768,1.768,0,0,0,5.009,3.763L5,13.459a1.776,1.776,0,0,0,1.778,1.763H19.222A1.776,1.776,0,0,0,21,13.459V5.526A1.776,1.776,0,0,0,19.222,3.763ZM16.556,11.7H9.444a.44.44,0,0,1-.356-.705l1.227-1.613a.443.443,0,0,1,.711,0l1.084,1.437L14.084,8.2a.443.443,0,0,1,.711,0l2.116,2.794A.44.44,0,0,1,16.556,11.7Z",
					transform: "translate(-5 -2)",
					fill: "#fff"
				})]
			})
		})]
	})]
});
const ForwardRef = forwardRef(SvgFolder);
export default ForwardRef;
